import './App.css';
import {Grid} from "@mui/material";
import Pagina from "./Pagina/Pagina";
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/800.css';
import {createContext, useEffect} from "react";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
export const contexApp = createContext()

function App() {
    const {data: categorias, actualizarDataLocal: actCategorias} = useObtenerDataActualizada({clave: 'categorias'})


    const valoresProvider = {
        categorias
    }

    const {Provider} = contexApp;

    useEffect(() => {

        //se verifica si esta o no actualizado
        obtenerFechaAct('categorias').then((dox) => {
            let w = []
            actCategorias({fecha: dox, wheres: w}).then()
        })


    }, []);

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Provider value={valoresProvider}>

                <Pagina/>

            </Provider>

        </Grid>
    );
}

export default App;
